import { Box, Image } from '@domain-group/suit-theme'

import type { AttachmentModel } from '@models/attachment'

import DownloadButton from './DownloadButton'
import Outdated from './Outdated'

interface AttachmentParams {
  attachment: AttachmentModel,
  outdated?: boolean,
}

const Attachment = (params: AttachmentParams) => {
  const { attachment, outdated } = params

  const {
    dimensions,
    file_content_type: contentType,
    links,
  } = attachment

  if (contentType?.match(/image/) && dimensions && links){
    const imageUrl = links?.thumb_url
    // @ts-expect-error TS18048
    const width = dimensions?.thumb.width ? parseInt(dimensions?.thumb.width.toString(), 10) / 2.5 : 0
    // @ts-expect-error TS18048
    const height = dimensions?.thumb.height ? parseInt(dimensions?.thumb.height.toString(), 10) / 2.5 : 0

    return (
      <Box
        border="1px solid"
        borderColor="lineColor"
        borderRadius="5px"
        onClick={() => console.log('To implement showAttachmentPreviewModal')}
      >
        <Box
          position="relative"
          borderRadius={outdated ? 'inherit' : '5px'}
          height={height || 160}
          width={width}
          overflow="hidden"
        >
          <Image height="100%" url={imageUrl} />

          {outdated && (
            <Outdated />
          )}
        </Box>
      </Box>
    )
  }

  if (links) return <DownloadButton links={links} />

  return null
}

export default Attachment
